import {
  getUserId,
  init,
  reset,
  setUserId,
  track
} from '@amplitude/analytics-browser';
import {
  AMPLITUDE_EVENT_TYPE,
  ANALYTICS_USER_TYPE,
  EXTERNAL_SERVICE
} from '@/analytics/constants';

let amplitudeApiKey;
let activeIdentity;
// Login starts a new page or WebView, so logout is final for this module.
let isLoggedOut = false;

export const initializeAmplitude = roleName => {
  amplitudeApiKey = {
    company: process.env.VUE_APP_AMPLITUDE_ENDCLIENT_KEY,
    influencer: process.env.VUE_APP_AMPLITUDE_INFLUENCER_KEY
  }[roleName];

  if (!amplitudeApiKey) {
    return;
  }

  try {
    init(amplitudeApiKey, {
      autocapture: false,
      defaultTracking: false
    }).promise.catch(() => undefined);
  } catch (error) {
    // Analytics failures must not affect chat.
  }
};

export const setExternalServiceErrorIdentity = (userId, userType) => {
  activeIdentity = undefined;

  if (
    isLoggedOut ||
    !amplitudeApiKey ||
    typeof userId !== 'string' ||
    !userId ||
    (userType !== ANALYTICS_USER_TYPE.BUSINESS &&
      userType !== ANALYTICS_USER_TYPE.INFLUENCER)
  ) {
    return;
  }

  try {
    setUserId(userId);
    activeIdentity = { userId, userType };
  } catch (error) {
    // Analytics failures must not affect chat.
  }
};

export const resetExternalServiceErrorIdentity = () => {
  isLoggedOut = true;
  activeIdentity = undefined;

  try {
    reset();
  } catch (error) {
    // Analytics failures must not affect chat.
  }
};

export const reportExternalServiceError = ({ service, action_type, error }) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!activeIdentity || getUserId() !== activeIdentity.userId) return;

    const errorCode =
      error && typeof error.code === 'string' && error.code
        ? error.code
        : undefined;
    if (
      service === EXTERNAL_SERVICE.FIRESTORE &&
      errorCode === 'permission-denied' &&
      typeof error.message === 'string' &&
      /\btoken\s+(?:(?:has|is)\s+)?expired\b|\bexpired\s+(?:(?:id|auth)\s+)?token\b/i.test(
        error.message
      )
    ) {
      return;
    }
    const eventProperties = {
      user_type: activeIdentity.userType,
      action_type,
      service,
      error_code: errorCode,
      error_message: error && error.message,
      page_url: window.location.origin + window.location.pathname
    };

    track(
      AMPLITUDE_EVENT_TYPE.EXTERNAL_SERVICE_ERROR,
      eventProperties
    ).promise.catch(() => undefined);
  } catch (error) {
    // Analytics failures must not affect chat.
  }
};

export const captureAndRethrowExternalServiceError = (
  service,
  action
) => error => {
  reportExternalServiceError({ service, action_type: action, error });
  throw error;
};
